// shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalLeadersComponent } from '../Components/global-leaders/global-leaders.component';
import { TestimonialComponent } from '../Components/testimonial/testimonial.component';
// import { GrammarTipsModalComponent } from '../Components/videos/grammar-tips/grammar-tips-modal/grammar-tips-modal.component';
// import { ProductWalkthroughtModalComponent } from '../Components/product-walkthrought-modal/product-walkthrought-modal.component';
// import { GetTrinkaComponent } from '../Components/enterprise/get-trinka/get-trinka.component';
import { RouterModule } from '@angular/router';
import { KeyFeaturesOfTrinkaComponent } from '../Components/key-features-of-trinka/key-features-of-trinka.component';
import { SafeSecureComponent } from '../Components/safe-secure/safe-secure.component';
import { BrowserDetectionComponent } from '../Components/browser-detection/browser-detection.component';
import { ManyToolsGrammarCheckerComponent } from '../Components/features/features-shared/many-tools-grammar-checker/many-tools-grammar-checker.component';
import { PowerModeSectionComponent } from '../Components/features/power-mode-section/power-mode-section.component';
import { GetTrinkaComponent } from '../Components/enterprise/get-trinka/get-trinka.component';
import { SuggestionAlertsComponent } from '../Components/features/features-shared/suggestion-alerts/suggestion-alerts.component';
import { SpecializesWritingComponent } from '../Components/features/features-shared/specializes-writing/specializes-writing.component';
import { DomainSpecificDictionariesComponent } from '../Components/features/features-shared/domain-specific-dictionaries/domain-specific-dictionaries.component';
import { SecuritySectionComponent } from '../Components/security-section/security-section.component';
import { ImportFilesComponent } from '../Components/features/features-shared/import-files/import-files.component';
import { CreditsInfoComponent } from '../Components/features/features-shared/credits-info/credits-info.component';
import { TrinkaInOtherAppsComponent } from '../Components/features/features-shared/trinka-in-other-apps/trinka-in-other-apps.component';
import { WhatMakeUsStandOutComponent } from '../Components/features/features-shared/what-make-us-stand-out/what-make-us-stand-out.component';
import { ParaphrasingModesComponent } from '../Components/features/features-shared/paraphrasing-modes/paraphrasing-modes.component';
import { FormsModule } from '@angular/forms';
import { AppsLibraryComponent } from '../Components/features/ai-studio/apps-library/apps-library.component';
import { AISuitableForComponent } from '../Components/features/ai-studio/aisuitable-for/aisuitable-for.component';
import { TrustedGlobalLeadersComponent } from '../Components/enterprise/trusted-global-leaders/trusted-global-leaders.component';
import { CompliancesCoveredComponent } from '../Components/enterprise/compliances-covered/compliances-covered.component';
import { HippaCertificateComponent } from '../Components/enterprise/hippa-certificate/hippa-certificate.component';
import { OfflineKeyFeaturesComponent } from '../Components/enterprise/offline-key-features/offline-key-features.component';
import { GrammarWithoutInternetComponent } from '../Components/enterprise/grammar-without-internet/grammar-without-internet.component';
import { EnterpriseFormComponent } from '../Components/enterprise/enterprise-form/enterprise-form.component';
import { DocumarkForUniversitiesComponent } from '../Components/features/features-shared/documark-for-universities/documark-for-universities.component';
import { JournalStepsComponent } from '../Components/journal-finder-tool/journal-steps/journal-steps.component';
import { AddToDictionaryComponent } from '../Components/features/features-shared/add-to-dictionary/add-to-dictionary.component';
//import { TrustedGlobalLeadersComponent } from '../Components/enterprise/trusted-global-leaders/trusted-global-leaders.component';

@NgModule({
  declarations: [
    GlobalLeadersComponent,
    KeyFeaturesOfTrinkaComponent,
    SafeSecureComponent,
    TestimonialComponent,
    BrowserDetectionComponent,
    ManyToolsGrammarCheckerComponent,
    PowerModeSectionComponent,
    GetTrinkaComponent,
    SuggestionAlertsComponent,
    SpecializesWritingComponent,
    DomainSpecificDictionariesComponent,
    SecuritySectionComponent,
    ImportFilesComponent,
    CreditsInfoComponent,
    TrinkaInOtherAppsComponent,
    WhatMakeUsStandOutComponent,
    ParaphrasingModesComponent,
    AppsLibraryComponent,
    AISuitableForComponent,
    TrustedGlobalLeadersComponent,
    CompliancesCoveredComponent,
    HippaCertificateComponent,
    OfflineKeyFeaturesComponent,
    GrammarWithoutInternetComponent,
    EnterpriseFormComponent,
    DocumarkForUniversitiesComponent,
    JournalStepsComponent,
    AddToDictionaryComponent
    // GrammarTipsModalComponent,
    // ProductWalkthroughtModalComponent,
    // GetTrinkaComponent,
    // TrustedGlobalLeadersComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ],
  exports: [
    GlobalLeadersComponent,
    KeyFeaturesOfTrinkaComponent,
    SafeSecureComponent,
    TestimonialComponent,
    BrowserDetectionComponent,
    ManyToolsGrammarCheckerComponent,
    PowerModeSectionComponent,
    GetTrinkaComponent,
    SuggestionAlertsComponent,
    SpecializesWritingComponent,
    DomainSpecificDictionariesComponent,
    SecuritySectionComponent,
    ImportFilesComponent,
    CreditsInfoComponent,
    TrinkaInOtherAppsComponent,
    WhatMakeUsStandOutComponent,
    ParaphrasingModesComponent,
    AppsLibraryComponent,
    AISuitableForComponent,
    TrustedGlobalLeadersComponent,
    CompliancesCoveredComponent,
    HippaCertificateComponent,
    OfflineKeyFeaturesComponent,
    GrammarWithoutInternetComponent,
    EnterpriseFormComponent,
    DocumarkForUniversitiesComponent,
    JournalStepsComponent,
    AddToDictionaryComponent
    // GrammarTipsModalComponent,
    // ProductWalkthroughtModalComponent,
    // GetTrinkaComponent,
    // TrustedGlobalLeadersComponent
  ]
})

export class SharedModule { }
